"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findNewestToolOutput = void 0;
const isOutputObject = (output) => typeof output === "object" && output !== null && !Array.isArray(output);
const findNewestToolOutput = (history, toolName, matches) => [...history]
    .reverse()
    .flatMap((message) => [...message.parts].reverse())
    .flatMap((part) => part.type === `tool-${toolName}` &&
    part.state === "output-available" &&
    isOutputObject(part.output) &&
    !("error" in part.output)
    ? [part.output]
    : [])
    .find((output) => matches(output)) ?? null;
exports.findNewestToolOutput = findNewestToolOutput;
